import script from "./vatInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./vatInvoice.vue?vue&type=script&setup=true&lang=js"

import "./vatInvoice.vue?vue&type=style&index=0&id=5bbb7f7c&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bbb7f7c"]])

export default __exports__